// src/services/companyService.js
import axios from 'axios';

const apiURL = process.env.REACT_APP_API_URI;

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

export const getCompanyInfo = async () => {
  try {
    const response = await axios.get(`${apiURL}/api/company`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error fetching company info:', error);
    throw error;
  }
};

export const getAssetUrl = (assetPath) => {
  if (!assetPath) return null;
  
  // Remove any leading slashes
  const cleanPath = assetPath.replace(/^\/+/, '');
  
  // Check if path already includes /api/assets
  if (cleanPath.startsWith('api/assets/') || cleanPath.startsWith('assets/')) {
    // Remove 'api/' if it exists twice
    const normalizedPath = cleanPath.replace(/^api\//, '');
    return `${apiURL}/api/${normalizedPath}`;
  }
  
  return `${apiURL}/api/assets/${cleanPath}`;
};

// Additional company-related API calls can be added here
export const updateCompanyInfo = async (companyData) => {
  try {
    const response = await axios.put(`${apiURL}/api/company`, companyData, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error updating company info:', error);
    throw error;
  }
};

export const uploadCompanyAsset = async (file, type) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);

    const response = await axios.post(`${apiURL}/api/company/assets/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading company asset:', error);
    throw error;
  }
};
